<template>
  <div>


    <div id="phoneModule">
      <div class="moduleContainer">
        <el-tabs @tab-click="handleClick">
          <el-tab-pane v-for="(item, key) in summitsList" :key="key" :label="item.name" />
        </el-tabs>
        <div class="phoneCont">
          <div class="videoContainer" v-if="false">
            <video controls style="object-fit: cover;" width="100%"
              :src="summitItemList.liveUrl || summitItemList.replayUrl"
              v-if="(summitItemList.liveUrl && loginStatus) || summitItemList.replayUrl"></video>
            <img v-else
              :src="summitItemList.summitPictures.length > 0 && summitItemList.summitPictures[0].summitGalleryPicture.showUrl || `https://wemeet-1302608036.cos.ap-shanghai.myqcloud.com/CEO%20summits/img/meetIntroduce.png?v=${new Date()}`"
              alt="" />
          </div>
          <div class="videoContent" v-if="false">
            <div class="name">
              {{ summitItemList.udfs && summitItemList.udfs.liveTitle || '2023国际会展业CEO上海峰会' }}
            </div>
            <div class="detail">
              <i class="iconfont icon-didian"></i>
              <span>地址：{{
                (summitItemList.address &&
                  summitItemList.address.detailAddress) ||
                '暂无地址'
              }}</span>
            </div>
            <div class="detail">
              <i class="iconfont icon-jianjie"></i>
              <span>简介：{{ summitItemList.description || '暂无简介' }}</span>
            </div>
          </div>

          <div class="hzAddress">会场地址：上海浦东丽思卡尔顿酒店（浦东陆家嘴世纪大道8号, 上海国金中心）</div>
          <div class="title" v-html="dailyDetail"></div>
          <div class="timeLine" v-for="(timeLine, key) in summitItemList.summitObj" :key="key">
            <div class="subSummit" v-if="key != 'null'">
              {{ key }}
              <div class="hostname" v-if="timeLine[0].udfs && timeLine[0].udfs.hostname">{{ timeLine[0].udfs.hostname }}</div>
            </div>
            <div class="timeItem" v-for="(item, index) in timeLine" :key="index">
              <div class="time">
                <div v-if="item.udfs.showtime != 'Y'">
                  {{ item.startEndTime.fromTime | formatHHMM }}-{{
                    item.startEndTime.toTime | formatHHMM
                  }}
                </div>

              </div>
              <div class="summitsContent">
                <div v-if="item.name" v-html="item.name"></div>
                <div class="hostname" v-if="item.udfs && item.udfs.hostname && index != 0" v-html="item.udfs.hostname">
                </div>
                <div class="guestList" v-if="item.eventShowGuests.length > 0">
                  <div class="guestItem" v-for="(sitem, sindex) in item.eventShowGuests" :key="sindex"
                    @click="showGuest(sitem)">
                    <img class="avatar"
                      :src="sitem.guest.poster && sitem.guest.poster.showUrl || `https://wemeet-1302608036.cos.ap-shanghai.myqcloud.com/CEO%20summits/img/tx.png?v=${new Date()}`"
                      alt="头像" />
                    <div class="userName">{{ $i18n.locale == 'zh-CN' ? sitem.guest.name : sitem.guest.foreignName }}</div>
                    <div class="position">
                      {{ sitem.guest.position }}
                    </div>
                  </div>
                </div>
              </div>
            </div>

          </div>


        </div>
      </div>
      <el-dialog :show-close="false" :visible.sync="dialogVisible" width="90%" :before-close="handleClose">
        <div class="dialogFlex">
          <span>2023国际会展业CEO上海峰会</span>
          <div @click="handleClose()" class="close">X</div>
        </div>
        <div class="dialogName">嘉宾介绍</div>
        <div class="dialogCon">
          <img class="avatar"
            :src="guest.avatar && guest.avatar.fileUrl || `https://wemeet-1302608036.cos.ap-shanghai.myqcloud.com/CEO%20summits/img/tx.png?v=${new Date()}`"
            alt="头像" />
          <div class="userName">{{ $i18n.locale == 'zh-CN' ? guest.name : guest.foreignName }}</div>
          <div class="position">
            {{ guest.position || '暂无职位介绍' }}
          </div>
          <div class="guestTit">嘉宾介绍</div>
          <div class="guestInfo" v-html="guest.introduction" v-if="guest.introduction">
          </div>
          <div class="guestInfo" v-else>
            暂无嘉宾介绍
          </div>
        </div>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import moment from '@/utils/moment'
export default {
  name: "wmt-summits",
  data() {
    return {
      activeName: "first",
      loginStatus: '',
      dailyDetail: '日程详情 <span class="smTit">（最新更新日期：6月13日）</span>',
      timeLine: [],
      dialogVisible: false,
      summitsList: [],
      summitItemList: {
        address: {
          detailAddress: "",
        },
      },
      guest: {
        avatar: {
          fileUrl: "",
        },
        poster: {
          showUrl: "",
        },
      },
    };
  },
  filters: {
    formatHHMM(val) {
      if (!val) {
        return
      }
      return moment(val).utcOffset(480).format('HH:mm');
    },
  },
  created() { },
  mounted() {
    let summitsList
    this.$http({
      method: 'get',
      url: 'https://wemeet-1302608036.cos.ap-shanghai.myqcloud.com/CEO-WXMINI/data/summit.json'
    }).then(res => {
      let data = res
      summitsList = data.filter((item) => item.status == "ACTIVE");
      summitsList.forEach((item) => {
        let summitObj = {};
        if (item.eventShows.length != 0) {
          item.eventShows.forEach((sitem) => {
            if (sitem.introduction) {
              sitem.introduction = JSON.parse(sitem.introduction)

            } else {
              sitem.introduction = ''
            }
            let key = sitem.udfs && sitem.udfs.subsummit || null
            if (!summitObj[key]) {
              summitObj[key] = [];
            }
            summitObj[key].push(sitem);
          });
          item.summitObj = summitObj;
        }

      });
      this.summitsList = summitsList;
      this.summitItemList = this.summitsList[0];

    })

  },
  methods: {
    handleClick(tab) {
      if (this.summitIndex != tab.index) {
        this.summitItemList = this.summitsList[tab.index];
      }
    },
    handleClose() {
      this.dialogVisible = false
      this.guest = {
        avatar: {
          fileUrl: "",
        },
        poster: {
          showUrl: "",
        },
      }
    },
    showGuest(item) {
      this.guest = item.guest;
      console.log(this.guest);
      this.dialogVisible = true;
    },
  },
};
</script>

<style lang="less" scoped>
#singleModule {

  height: auto !important;
  padding-bottom: 200px;
  padding-top: 10px;
  background: #fff !important;

  /deep/ .smTit {
    font-size: 18px;
  }

  .title {
    font-size: 22px;
    font-weight: 500;
    color: #333333;
    position: relative;
    padding-left: 12px;
    margin-top: 46px;

    &::before {
      content: "";
      position: absolute;
      top: 0;
      left: 0;
      width: 6px;
      height: 30px;
      background: #38b3db;
    }
  }

  .hzAddress {
    font-size: 16px;
    color: #999;
    padding-top: 10px;
  }

  .videoBox {
    margin-top: 23px;

    .videoContainer {
      display: flex;
      height: 490px;

      img {
        width: 100%;
        height: 100%;
      }
    }

    .descBox {
      height: 490px;
      background: #195190;

      .topHeader {
        width: 100%;
        height: 50px;
        background: #3073bf;
        font-size: 14px;
        font-weight: 500;
        color: #ffffff;
        text-align: center;
        line-height: 50px;
      }

      .videoContent {
        padding: 28px 30px;

        .name {
          font-size: 20px;
          font-weight: 500;
          color: #ffffff;
        }

        .detail {
          margin-top: 14px;
          margin-bottom: 13px;
          display: flex;

          i {
            font-size: 24px;
            color: #fff;
            margin-right: 5px;
            position: relative;
            top: -7px;
          }

          span {
            font-size: 14px;
            font-weight: 400;
            color: #ffffff;
          }
        }
      }
    }
  }

  .timeLine {
    margin-top: 45px;
    padding: 0 5px;

    .hostname {
      font-size: 18px;
      color: #666;
    }

    .subSummit {
      margin-bottom: 56px;
      font-size: 20px;
      color: #333;
    }

    .timeItem {
      display: flex;
      border-left: 1px dashed #38b3db;
      min-height: 120px;
      padding-left: 10px;
      position: relative;

      &:last-child {
        border-left: none;
      }

      &::before {
        content: "";
        position: absolute;
        top: 0;
        left: -5px;
        width: 10px;
        height: 10px;
        border-radius: 50%;
        background: #38b3db;
      }

      .time {
        font-size: 18px;
        font-weight: 500;
        color: #38b3db;
        position: relative;
        top: -8px;
        width: 132px;
      }

      .summitsContent {
        font-size: 18px;
        font-weight: 500;
        color: #333333;
        margin-left: 60px;
        position: relative;
        top: -8px;

        .guestList {
          width: calc(1320px - 200px);
          min-height: 260px;
          padding: 50px 0;
          background: #f7feff;
          margin-top: 35px;
          margin-bottom: 80px;
          display: grid;
          grid-column-gap: 10px;
          grid-row-gap: 30px;
          /* 一行放两列、两个auto */
          grid-template-columns: auto auto auto auto;
          justify-content: space-around;

          .guestItem {
            text-align: center;
            width: 200px;
            cursor: pointer;

            .avatar {
              width: 100px;
              height: 100px;
              border-radius: 50%;
            }

            .userName {
              font-size: 16px;
              font-weight: 500;
              color: #333333;
              margin-top: 14px;
              margin-bottom: 7px;
            }

            .position {
              font-size: 14px;
              font-weight: 400;
              color: #333333;
            }
          }
        }
      }
    }
  }
}

#phoneModule {

  height: auto !important;
  padding-bottom: 40px;
  padding-top: 10px;
  background: #fff !important;

  .phoneCont {
    padding: 0 14px;
    text-align: left;
  }

  /deep/ .smTit {
    font-size: 12px;
  }

  .title {
    font-size: 16px;
    font-weight: 500;
    color: #343233;
  }

  .videoContainer {
    height: 190px;
    display: flex;

    img {
      width: 100%;
      height: 100%;
    }
  }

  .videoBox {
    margin-top: 23px;
  }

  .hzAddress {
    font-size: 12px;
    color: #999;
    padding: 10px 0;
  }

  .videoContent {
    padding: 12px 0px;
    color: #777;

    .name {
      font-size: 16px;
      font-weight: 500;
      color: #333;
    }

    .detail {
      margin-top: 10px;
      margin-bottom: 10px;
      display: flex;

      i {
        font-size: 14px;
        color: #777;
        margin-right: 4px;
        position: relative;
      }

      span {
        font-size: 14px;
        font-weight: 400;
        color: #777;
      }
    }
  }

  .descBox {
    height: 490px;
    background: #195190;

    .topHeader {
      width: 100%;
      height: 50px;
      background: #3073bf;
      font-size: 14px;
      font-weight: 500;
      color: #ffffff;
      text-align: center;
      line-height: 50px;
    }
  }

  .subSummit {
    margin-bottom: 15px;
    color: #343233;
    font-size: 16px;
  }

  .timeLine {
    margin-top: 15px;
    padding: 0 5px;

    .hostname {
      font-size: 15px;
      color: #666;
    }

    .timeItem {
      border-left: 1px dashed #38b3db;
      min-height: 76px;
      padding-left: 10px;
      position: relative;

      &:last-child {
        border-left: none;
      }

      &::before {
        content: "";
        position: absolute;
        top: 0;
        left: -5px;
        width: 10px;
        height: 10px;
        border-radius: 50%;
        background: #38b3db;
      }

      .time {
        font-size: 15px;
        font-weight: 500;
        color: #38b3db;
        position: relative;
        top: -8px;
        width: 200px;
      }

      .summitsContent {
        font-size: 15px;
        font-weight: 500;
        color: #333333;
        position: relative;
        top: -8px;
        padding-bottom: 20px;

        /deep/ .smfont {
          font-size: 12px;
          color: #666;
        }

        .guestList {
          width: 324px;
          min-height: 140px;
          padding: 16px 0;
          background: #f7feff;
          margin-top: 15px;
          display: grid;
          grid-column-gap: 10px;
          grid-row-gap: 30px;
          /* 一行放两列、两个auto */
          grid-template-columns: auto auto;
          justify-content: space-around;

          .guestItem {
            text-align: center;
            width: 130px;
            cursor: pointer;

            .avatar {
              width: 60px;
              height: 60px;
              border-radius: 50%;
            }

            .userName {
              font-size: 14px;
              font-weight: 500;
              color: #333333;
              margin-top: 10px;
              margin-bottom: 2px;
            }

            .position {
              font-size: 12px;
              font-weight: 400;
              color: #333333;
              white-space: nowrap;
              overflow: hidden;
              text-overflow: ellipsis;
            }
          }
        }
      }
    }
  }
}
</style>


<style lang="less">
#singleModule {
  .el-tabs__item {
    padding: 0 60px;
    font-size: 20px;
    font-weight: 600;
    color: #777777;
  }

  .el-tabs__item.is-active {
    font-size: 20px;
    font-weight: 600;
    color: #38b3db;
  }

  .timeLine {
    .el-timeline-item__content {}
  }

  .el-dialog {
    background: linear-gradient(136deg, #0ad9b7 0%, #1e4689 100%);
  }

  .el-dialog__header {
    padding: 0;
  }

  .el-dialog__body {
    padding: 13px;
  }

  .dialogFlex {
    display: flex;
    justify-content: space-between;
    align-items: center;
    color: #fff;

    span {
      font-size: 13px;
    }
  }

  .dialogName {
    font-size: 16px;
    color: #fff;
    margin: 4px 0 9px 0;
  }

  .dialogCon {
    margin: 0 auto;
    background: #fff;
    border-radius: 6px;
    padding: 29px 25px;
    display: flex;

    .avatar {
      width: 243px;
      height: 328px;
      margin-right: 32px;
    }

    .userName {
      margin-bottom: 10px;
      color: #333;
      font-size: 16px;
    }

    .position {
      font-size: 13px;
      color: #777;
    }

    .guestTit {
      color: #333;
      font-size: 13px;
      margin: 10px 0;
    }

    .guestInfo {
      height: 215px;
      overflow-y: auto;
      color: #777;
      font-size: 13px;
    }
  }

  .close {
    font-size: 20px;
    cursor: pointer;
  }
}

#phoneModule {
  .el-tabs__nav-scroll {
    padding: 0 15px;
  }

  .el-tabs__item {
    // padding: 0 15px;
    font-size: 16px;
    font-weight: 600;
    color: #777777;
  }

  .el-tabs__item.is-active {
    font-size: 16px;
    font-weight: 600;
    color: #38b3db;
  }

  .timeLine {
    .el-timeline-item__content {}
  }

  .el-dialog {
    background: linear-gradient(136deg, #0ad9b7 0%, #1e4689 100%);
  }

  .el-dialog__header {
    padding: 0;
  }

  .el-dialog__body {
    padding: 13px;
    text-align: left;
  }

  .dialogFlex {
    display: flex;
    justify-content: space-between;
    align-items: center;
    color: #fff;

    span {
      font-size: 13px;
    }
  }

  .dialogName {
    font-size: 16px;
    color: #fff;
    margin: 4px 0 9px 0;
  }

  .dialogCon {
    margin: 0 auto;
    background: #fff;
    border-radius: 6px;
    padding: 15px 13px;

    .avatar {
      width: 60px;
      height: 60px;
      border-radius: 50%;
    }

    .userName {
      margin-top: 12px;
      margin-bottom: 10px;
      color: #333;
      font-size: 16px;
    }

    .position {
      font-size: 13px;
      color: #777;
    }

    .guestTit {
      color: #333;
      font-size: 13px;
      margin: 10px 0;
    }

    .guestInfo {
      color: #777;
      font-size: 13px;
      max-height: 260px;
      overflow-y: auto;
      padding-bottom: 30px;
    }
  }

  .close {
    font-size: 18px;
    cursor: pointer;
  }
}</style>